import { LoginButton } from "../../components/LoginButton";
import { Helmet } from "react-helmet-async";

const LoginPage = () => {
    return (
        <>
            <Helmet>
                <title>AskEllie | Login</title>
            </Helmet>
            <div className="login-background relative w-screen h-screen overflow-hidden py-[50px] md:pb-[50px] md:pt-[0px] flex flex-col md:justify-center justify-start">
                <div className="relative z-[1]">
                    <div className="ml-[20px] sm:ml-[70px] xl:ml-[140px] flex flex-col gap-[20px] justify-center">
                        <div className="z-[4] max-w-[540px] text-eq-white flex flex-col gap-[20px]">
                            <div className="text-[50px] xl:text-[74px] 2xl:text-[100px] font-thin leading-[56px] xl:leading-[80px]">AskEllie</div>
                            <div className="text-[16px] font-normal w-11/12 md:w-full">
                                Your friendly assistant, powered by the latest OpenAI large language models.
                            </div>
                        </div>
                        <LoginButton />
                    </div>
                </div>
            </div>
        </>
    );
};

export default LoginPage;
